import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from 'primeng/api';
import { DialogComponent } from '../dialog/dialog.component';

import { TableData } from '../../../table-overlay/table-overlay';

@Component({
  selector: 'ct-extraction-edit-dialog',
  imports: [ConfirmDialogModule, SharedModule, DialogComponent],
  templateUrl: './edit-dialog.component.html',
})
export class EditDialogComponent {
  @Input({ required: true }) tableData!: TableData;

  @Output() acceptedDialog = new EventEmitter<void>();
}
